import { For } from '../c-mp/comp/For'
import { Icon } from '../c-mp/comp/Icon'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { url } from '../c-mp/fun/url'
import { andrisEmail } from '../fun/andrisEmail'
import { expectDefined } from '../fun/expectDefined'
import { getAge } from '../fun/getAge'
import { getChildren } from '../fun/getChildren'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { getSpouses } from '../fun/getSpouses'
import { getTodayIsoDate } from '../fun/getTodayIsoDate'
import { isDead } from '../fun/isDead'
import { onLinkClickFocusSearchInput } from '../fun/onLinkClickFocusSearchInput'
import { setPageTitle } from '../fun/setPageTitle'
import { ICON_EMAIL } from '../icon/ICON_EMAIL'
import { ICON_MARRIED } from '../icon/ICON_MARRIED'
import { ICON_PLUS } from '../icon/ICON_PLUS'
import { ICON_SEARCH } from '../icon/ICON_SEARCH'
import { ICON_TREE } from '../icon/ICON_TREE'
import { addYears } from '../model/addYears'
import { _ } from '../model/ccc'
import { PERSON_DETAILS } from '../model/PERSON_DETAILS'
import { Relationship } from '../model/Relationship'
import { PersonLinkComp } from './PersonLinkComp'

export const PageHomeComp = defineComponent<{}>('PageHomeComp', (props, $) => {
	setPageTitle('')

	const lajosId = '1898-11-09-Parditka-Lajos'

	const data = getDataOrThrow()

	return (
		<div class={_.ccc_page}>
			<h1>
				<b class={_.ccc_parditka}>Parditka</b> családfa
			</h1>
			<div class={_.ccc_tiles__centered}>
				<a class={_.ccc_button__rounded} href='/quiz'>
					❓Kvíz
				</a>
			</div>
			<h2>
				<b>Parditka Lajos</b> családja
			</h2>
			<div class={_.ccc_tiles__centered}>
				<For
					debugName='Parditka Lajos családja: szülők'
					each={() => [
						expectDefined(data.personsById[lajosId]),
						...getSpouses(data, lajosId),
					]}
					render={PersonLinkComp}
				/>
			</div>
			<div class={_.ccc_tiles__centered}>
				<For
					debugName='Parditka Lajos családja: gyerekek'
					each={() => getChildren(data, lajosId)}
					render={PersonLinkComp}
				/>
			</div>
			<div class={_.ccc_tiles__centered}>
				<a class={_.ccc_button__rounded} href={url`/person/${lajosId}/tree`}>
					<Icon svg={ICON_TREE} /> <b>Parditka Lajos</b> családfájának rajza
				</a>
			</div>
			<h2>
				<b>Élő</b> Parditkák
			</h2>
			<div class={_.ccc_tiles__centered}>
				<For
					debugName='Élő Parditkák'
					each={() =>
						Object.values(data.personsById).filter(
							(it) =>
								it.relationship === Relationship.Parditka &&
								!isDead(data, it) &&
								getAge(it.birthDate) != null,
						)
					}
					render={PersonLinkComp}
				/>
				<a
					class={_.ccc_button__plus}
					href={() =>
						andrisEmail(
							`Új Parditka`,
							`És az élő Parditkák részben hiányoltam valakit:\n\n${PERSON_DETAILS}`,
						)
					}
					title='Új Parditka'
				>
					<Icon svg={ICON_PLUS} /> Parditka
				</a>
			</div>
			<h2>
				Az elmúlt 20 évben <b>elhunyt</b> Parditkák
			</h2>
			<div class={_.ccc_tiles__centered}>
				<For
					debugName='Elhunyt Parditkák'
					each={() => {
						const cutoff = addYears(getTodayIsoDate(), -20)
						return Object.values(data.personsById)
							.filter(
								(it) =>
									it.relationship === Relationship.Parditka &&
									it.deathDate &&
									it.deathDate >= cutoff,
							)
							.sort((a, b) => b.deathDate!.localeCompare(a.deathDate!))
					}}
					render={PersonLinkComp}
				/>
				<a
					class={_.ccc_button__plus}
					href={() =>
						andrisEmail(
							`Elhunyt Parditka`,
							`És az elmúlt 20 évben elhunyt Parditkák részben hiányoltam valakit:\n\n`,
						)
					}
				>
					<Icon svg={ICON_PLUS} /> elhunyt Parditka
				</a>
			</div>
			<div class={_.ccc_tiles__centered}>
				<a class={_.ccc_button__rounded} href='/search?query=Parditka%20%2B'>
					Minden elhunyt Parditka
				</a>
			</div>
			<h2>
				Az elmúlt 20 évben <b>elhunyt</b> rokonok
			</h2>
			<div class={_.ccc_tiles__centered}>
				<For
					debugName='Elhunyt rokonok'
					each={() => {
						const cutoff = addYears(getTodayIsoDate(), -20)
						return Object.values(data.personsById)
							.filter(
								(it) =>
									it.relationship !== Relationship.Parditka &&
									it.deathDate &&
									it.deathDate >= cutoff,
							)
							.sort((a, b) => b.deathDate!.localeCompare(a.deathDate!))
					}}
					render={PersonLinkComp}
				/>
				<a
					class={_.ccc_button__plus}
					href={() =>
						andrisEmail(
							`Elhunyt rokon`,
							`És az elmúlt 20 évben elhunyt rokonok részben hiányoltam valakit:\n\n`,
						)
					}
				>
					<Icon svg={ICON_PLUS} /> elhunyt rokon
				</a>
			</div>
			<h2>További érdekes oldalak</h2>
			<div class={_.ccc_tiles__centered__compact}>
				<a class={_.ccc_button__rounded} href='/quiz'>
					❓Kvíz
				</a>
				<a class={_.ccc_button__rounded} href={`/birthdays`}>
					🎂 Születésnapok
				</a>
				<a class={_.ccc_button__rounded} href={`/wedding-anniversaries`}>
					<Icon svg={ICON_MARRIED} /> Házassági évfordulók
				</a>
				<a class={_.ccc_button__rounded} href={`/emails`}>
					<Icon svg={ICON_EMAIL} />
					Email címek
				</a>
			</div>
			<div class={_.ccc_tiles__centered__compact}>
				<a class={_.ccc_button__rounded} href='/relatives-alive'>
					Élő <b>rokonok</b>
				</a>
				<a class={_.ccc_button__rounded} href='/parentless'>
					Ősök
				</a>
				<a class={_.ccc_button__rounded} href='/clouds'>
					Felhők
				</a>
				<a class={_.ccc_button__rounded} href={`/average-age`}>
					Átlagos életkor
				</a>
			</div>
			<div class={_.ccc_tiles__centered__compact}>
				<a
					class={_.ccc_button__rounded}
					href={`/search`}
					onclick={onLinkClickFocusSearchInput}
				>
					<Icon svg={ICON_SEARCH} />
					Kereső
				</a>
				<a class={_.ccc_button__rounded} href={`/search?query=%2B`}>
					Minden elhunyt
				</a>
				<a class={_.ccc_button__rounded} href={`/search?query=%3A)`}>
					Mindenki élő
				</a>
			</div>
		</div>
	)
})
